import { PoolPricingMethod } from '@thinkalpha/locates-ws-client';
import type { PoolPricingConfig } from '@thinkalpha/locates-ws-client';

/**
 * Seed config for the pricing editor (PLAT-12937) when a pool has no
 * pricing configured yet. Uses the hierarchy order from the spec example;
 * the minimum-price input is left absent until an admin enables it.
 */
export const DEFAULT_POOL_PRICING_CONFIG = {
    hierarchy: [
        PoolPricingMethod.FairValue,
        PoolPricingMethod.Reference,
        PoolPricingMethod.Cached,
        PoolPricingMethod.Admin,
    ],
} satisfies PoolPricingConfig;
